import { SET_API_JSON, SET_API_JSON_ERROR } from "../ActionName/ActionName";

// Cart action types
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
export const CLEAR_CART = "CLEAR_CART";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PAGINATION = "SET_PAGINATION_BUYSTOCK";

const initialState = {
    apiJson: {},
    apiJsonError: {},
    products: [],
    cart: [],
    pagination: { page: 1, limit: 50, total: 0, totalPages: 0 },
    timestamp: Date.now()
}

const BuyStockReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_API_JSON:
            return ({ ...state, apiJson: action.value, timestamp: Date.now() })
        case SET_API_JSON_ERROR:
            return ({ ...state, apiJsonError: action.value, timestamp: Date.now() })

        case SET_PRODUCTS:
            return { ...state, products: action.payload, timestamp: Date.now() }

        case SET_PAGINATION:
            return { ...state, pagination: action.payload, timestamp: Date.now() }

        case ADD_TO_CART: {
            const existingItem = state.cart.find(item => item._id === action.payload._id);

            if (existingItem) {
                // Update quantity if item already exists
                return {
                    ...state,
                    cart: state.cart.map(item =>
                        item._id === action.payload._id
                            ? { ...item, quantity: item.quantity + (action.payload.quantity || 1) }
                            : item
                    ),
                    timestamp: Date.now()
                };
            } else {
                // Add new item to cart
                return {
                    ...state,
                    cart: [...state.cart, { ...action.payload, quantity: action.payload.quantity || 1 }],
                    timestamp: Date.now()
                };
            }
        }

        case REMOVE_FROM_CART:
            return {
                ...state,
                cart: state.cart.filter(item => item._id !== action.payload),
                timestamp: Date.now()
            }

        case UPDATE_CART_QUANTITY: {
            const { productId, quantity } = action.payload;

            if (quantity <= 0) {
                // Remove item if quantity is 0 or less
                return {
                    ...state,
                    cart: state.cart.filter(item => item._id !== productId),
                    timestamp: Date.now()
                };
            }

            return {
                ...state,
                cart: state.cart.map(item =>
                    item._id === productId
                        ? { ...item, quantity }
                        : item
                ),
                timestamp: Date.now()
            };
        }

        case CLEAR_CART:
            return {
                ...state,
                cart: [],
                timestamp: Date.now()
            }

        default:
            return state;
    }
}

export default BuyStockReducer;